/**
 * HTTP通信のユーティリティクラス
 */

import axios, { AxiosResponse, CancelTokenSource } from 'axios';
import AuthenticateUtil from '@/util/AuthenticateUtil';
import { Guid } from "guid-typescript";

declare const app_version: string;
declare const agent_guid: string;
declare const judge_guid: string;
declare const tenant_key: string;
declare const private_key: string;


/* eslint-disable  @typescript-eslint/no-explicit-any */
/* eslint-disable  @typescript-eslint/explicit-module-boundary-types */

export default class HttpRequestUtil {


    // Hash対象文字列取得
    static getHashTarget(
        body: string,
        salt: string
    ): string {

        // BODY
        let target: string = body;
        // HTTPヘッダ名称で昇順ソート
        target += agent_guid;   // x-skysea-agent-guid
        target += app_version;  // x-skysea-app-version
        target += judge_guid;   // x-skysea-judge-guid
        target += salt;         // x-skysea-salt
        target += tenant_key;   // x-skysea-tenant-key

        return target;
    }

    /**
      * @brief	POSTリクエスト
      * @note   ログインセッションが切れている場合はメッセージを表示します。
      * @param  [in]    url         URL
      * @param  [in]    data        送信データ
      * @return	結果
      */
    static async post(
        url: string,
        data: any
    ): Promise<AxiosResponse> {

        const body = JSON.stringify(data);
        console.log("★data:[" + body + "]");

        // ランダム値生成
        const salt = Guid.create().toString();
        // Hash対象文字列取得
        const target = HttpRequestUtil.getHashTarget(body, salt);
        // 署名(DEBUG_APPCATALOG)
        const signature = await AuthenticateUtil.Sign(target, private_key);

        let res = null;
        try {
            res = await axios.post(
                url,
                data,
                {
                    headers: {
                            'x-skysea-app-version': app_version,
                            'x-skysea-agent-guid': agent_guid,
                            'x-skysea-judge-guid': judge_guid,
                            'x-skysea-salt': salt,
                            'x-skysea-signature': signature,
                            'x-skysea-tenant-key': tenant_key,
                            'X-Requested-With': 'XMLHttpRequest'
                    },
                    cancelToken: this.token()
                }
            );
        } catch (error: any) {
            // キャンセルされたものかどうか？
            if (axios.isCancel(error)) {
                const retCancel: any = { status: 499 }
                // 非標準ですがnginxでクライアント側から切断された時に使われているコードと同じ499を使用。
                return retCancel;
            }

            // res.statusがないことがあるためtryで囲む。
            try {
                res = error.response;
            } catch (errorRes: any) {
                const retInternalServerError: any = { status: 500 }
                return retInternalServerError;
            }
        }

        return res;
    }

    /**
      * @brief	GETリクエスト
      * @note   ログインセッションが切れている場合はメッセージを表示します。
      * @param  [in]    url         URL
      * @return	結果
      */
    static async get(
        url: string
    ): Promise<AxiosResponse> {

        // ランダム値生成
        const salt = Guid.create().toString();
        // Hash対象文字列取得(bodyは常に空)
        const target = HttpRequestUtil.getHashTarget("", salt);
        // 署名(DEBUG_APPCATALOG)
        const signature = await AuthenticateUtil.Sign(target, private_key);

        let res = null;
        try {
            res = await axios.get(
                url,
                {
                    headers: {
                            'x-skysea-app-version': app_version,
                            'x-skysea-agent-guid': agent_guid,
                            'x-skysea-judge-guid': judge_guid,
                            'x-skysea-salt': salt,
                            'x-skysea-signature': signature,
                            'x-skysea-tenant-key': tenant_key,
                            'X-Requested-With': 'XMLHttpRequest'
                    },
                    cancelToken: this.token()
                }
            );
        } catch (error: any) {

            // キャンセルされたものかどうか？
            if (axios.isCancel(error)) {
                const retCancel: any = { status: 499 }
                // 非標準ですがnginxでクライアント側から切断された時に使われているコードと同じ499を使用。
                return retCancel;
            }

            // res.statusがないことがあるためtryで囲む。
            try {
                res = error.response;
            } catch (errorRes: any) {
                const retInternalServerError: any = { status: 500 }
                return retInternalServerError;
            }
        }

        return res;
    }

    /**
     * @brief	キャンセルトークンソース
     */
    private static cancelTokenSource: CancelTokenSource = axios.CancelToken.source();

    /**
     * @brief   リクエストのキャンセル
     */
    public static cancel() {
        this.cancelTokenSource.cancel();
        this.cancelTokenSource = axios.CancelToken.source();
    }

    /**
     * @brief   キャンセルトークンの取得
     */
    private static token() {
        return this.cancelTokenSource.token;
    }
}

